export default __webpack_public_path__ + "static/media/forgot-success.5411fd82.svg";